import { render } from "./vlabelmanage.vue?vue&type=template&id=6d0d1095&scoped=true"
import script from "./vlabelmanage.vue?vue&type=script&lang=js"
export * from "./vlabelmanage.vue?vue&type=script&lang=js"

import "./vlabelmanage.vue?vue&type=style&index=0&id=6d0d1095&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0d1095"]])

export default __exports__